import React from 'react';
import './KYCSettingsComponent.css';
import KYCComponent from './KYC';

const KYCSettingsComponent = () => {
  return <KYCComponent />;
};

export default KYCSettingsComponent;
